var ProductInformation = {
  getProductName(productId) {
    let productString = "";
    switch (productId) {
      case 7352:
        productString = "alerttree-v1";
        break;
      case 438:
        productString = "insight-water-meter-049";
        break;
      case 8263:
        productString = "hubbie-v100";
        break;
      case 8186:
        productString = "misc-v100";
        break;
      case 540:
        productString = "power-meter-v100";
        break;
      case 6299:
        productString = "sumpie-v100";
        break;
      case 16774:
        productString = "pace-16774";
        break;
      case 19494:
        productString = "sr-ii-19494";
        break;
      default:
        console.log("Unexpected Product Id: " + String(productId));
    }
    return productString;
  },
};

export default ProductInformation;
